import { PlainButton } from "@jugl-web/ui-kit";
import { useClipboard, useTranslations } from "@jugl-web/utils";
import { useManageAccountsDrawer } from "@web-src/modules/client-support/pages/ClientSupportPage/components/ManageAccountsDrawer/providers/ManageAccountsDrawerContext";
import { useVoiceAccount } from "@web-src/modules/client-support/pages/ClientSupportPage/components/ManageAccountsDrawer/hooks/useVoiceAccount";
import React from "react";
import { ChannelPreviewPanel } from "../ChannelPreviewPanel";
import { ReactComponent as SettingsIcon } from "./assets/settings.svg";
import { ReactComponent as VoiceIcon } from "./assets/voice.svg";
import { ReactComponent as CopyIcon } from "./assets/copy.svg";
import phoneCallPreviewImage from "./assets/phone-call-preview.png";

export const VoicePreview: React.FC = () => {
  const { t } = useTranslations();
  const { copyToClipboard } = useClipboard();
  const { account } = useVoiceAccount();
  const { openManageAccountDrawer } = useManageAccountsDrawer();

  const phoneNumber = account?.phone_num || "";

  return (
    <ChannelPreviewPanel
      showInfoIcon={false}
      icon={
        <div className="flex h-18 w-18 shrink-0 items-center justify-center rounded-[18px] bg-white shadow-[-10.125px_11.25px_13.275px_rgba(60,60,60,0.16)]">
          <VoiceIcon className="h-10 w-10" />
        </div>
      }
      title={t({
        id: "cx-ai-agents-page.phone-calls-is-live",
        defaultMessage: "Phone Calls is Live",
      })}
      subtitle={t({
        id: "cx-ai-agents-page.phone-calls-preview-unavailable",
        defaultMessage: "* Preview is not available",
      })}
      action={{
        label: t({
          id: "common.settings",
          defaultMessage: "Settings",
        }),
        onClick: () => openManageAccountDrawer({ name: "voiceAccount" }),
        variant: "secondary",
        iconEnd: <SettingsIcon />,
      }}
      bannerContent={
        <div className="flex min-w-0 flex-col gap-4">
          {phoneNumber && (
            <div className="flex items-center gap-2">
              <span className="font-secondary text-base leading-[140%] font-medium text-dark">
                {phoneNumber}
              </span>
              <PlainButton
                className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border border-solid border-grey-300 bg-white transition-colors hover:bg-grey-100"
                onClick={() => copyToClipboard(phoneNumber)}
              >
                <CopyIcon />
              </PlainButton>
            </div>
          )}
          <span className="font-secondary text-sm leading-[150%] text-dark-600">
            {t({
              id: "cx-ai-agents-page.phone-calls-preview-description",
              defaultMessage:
                "All incoming calls to your connected phone number are automatically handled by your AI Agent. Make a test call to see it in action",
            })}
          </span>
        </div>
      }
      bannerIllustration={
        <img
          src={phoneCallPreviewImage}
          alt=""
          className="h-auto w-32.5 shrink-0 object-contain"
        />
      }
    />
  );
};
